const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgA2LightMode(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256.44 67.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode",
    "data-name": "Isolation Mode"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode-2",
    "data-name": "Isolation Mode"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "248.2 49.58 256.44 35.28 114.09 35.28 105.85 49.58 248.2 49.58",
    style: {
      fill: "#da410f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.91 14.3 157.12 0 142.87 0 134.61 14.3 148.91 14.3",
    style: {
      fill: "#da410f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.07,
    width: 14.3,
    height: 14.3,
    style: {
      fill: "#da410f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.26 31.94 139.48 17.64 125.23 17.64 116.97 31.94 131.26 31.94",
    style: {
      fill: "#5c5ab3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.26 49.58 139.48 35.28 125.23 35.28 116.97 49.58 131.26 49.58",
    style: {
      fill: "#7977e9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.43,
    width: 14.3,
    height: 14.3,
    style: {
      fill: "#5c5ab3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.43,
    y: 17.64,
    width: 14.3,
    height: 14.3,
    style: {
      fill: "#5c5ab3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.62 49.58 121.83 35.28 107.59 35.28 99.32 49.58 113.62 49.58",
    style: {
      fill: "#7977e9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.62 67.22 121.83 52.93 107.59 52.93 99.32 67.22 113.62 67.22",
    style: {
      fill: "#5c5ab3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.98 31.94 104.19 17.64 89.95 17.64 81.68 31.94 95.98 31.94",
    style: {
      fill: "#5c5ab3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.98 49.58 104.19 35.28 89.95 35.28 81.68 49.58 95.98 49.58",
    style: {
      fill: "#7a78ed"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.34 14.3 86.55 0 72.3 0 64.04 14.3 78.34 14.3",
    style: {
      fill: "#5c5ab3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.34 31.94 86.55 17.64 72.3 17.64 64.04 31.94 78.34 31.94",
    style: {
      fill: "#5c5ab3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.35 49.58 150.59 35.28 8.24 35.28 0 49.58 142.35 49.58",
    style: {
      fill: "#5c5ab3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.92,
    y: 52.93,
    width: 36.76,
    height: 14.3,
    style: {
      fill: "#5c5ab3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.7 14.3 68.91 0 54.66 0 46.4 14.3 60.7 14.3",
    style: {
      fill: "#5c5ab3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.7 49.58 68.91 35.28 54.66 35.28 46.4 49.58 60.7 49.58",
    style: {
      fill: "#5c5ab3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.86,
    width: 14.3,
    height: 14.3,
    style: {
      fill: "#5c5ab3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.86,
    y: 17.64,
    width: 14.3,
    height: 14.3,
    style: {
      fill: "#5c5ab3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.05 67.22 51.27 52.93 37.02 52.93 28.76 67.22 43.05 67.22",
    style: {
      fill: "#5c5ab3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.22,
    y: 35.28,
    width: 14.3,
    height: 14.3,
    style: {
      fill: "#5c5ab3"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA2LightMode);
export default __webpack_public_path__ + "static/media/A2LightMode.14425800ce2065304106d11aba6865f9.svg";
export { ForwardRef as ReactComponent };